const BaseParticle = require('BaseParticle');

cc.Class({
    extends: BaseParticle,

    start () {
    },

    reuse () {
        this.node.angle = 0;
        this.node.scale = 1;
    },

    play (isTopContainer) {
        this.node.active = true;
        const animation = this.node.getComponentInChildren(cc.Animation);

        animation.play('itemSpin');

        this.playRotate(isTopContainer);
    },

    // eslint-disable-next-line max-statements
    playRotate (isTopContainer) {
        const scaleOrigin = 0.3;
        const animTime = 3;

        let randScale;

        const angle = Math.round(Math.random()) === 0 ? 360 : -360;

        if (isTopContainer) {
            randScale = Math.random() * 0.1 + 0.1 + scaleOrigin;
        } else {
            randScale = Math.random() * 0.1 + scaleOrigin;
        }

        this.node.setScale(randScale,randScale);

        cc.tween(this.node).by(animTime, { angle }).start();
        // this.node.runAction(
        //     cc.rotateBy(animTime, angle)
        // );
    }
});
